<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex flex-start justify-md-start">
              <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                <v-icon class="mr-2">mdi-printer</v-icon>
                Print
              </v-btn>
              <v-btn color="success" class="button-shadow" to="/batchdeposit/list">
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="8" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width:40%"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Deposit Num</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.depositnum }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ new Date(initvalue.depositdate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                         </table> 

                      </td>
                    </tr>
                    <tr>
                      <td colspan="3"><div align="center"><h4 class="ma-0">Batch Deposit</h4></div></td>
                    </tr>
                  </table>
                </v-row>
                <v-row class="mb-5 greyBold--text" cols="12">
                  <v-col cols="12">
                  
                  </v-col>
                </v-row>
                <v-row class="mb-5 greyBold--text">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;" cellpadding="0" cellspacing="0">
                    <tr>
                      <td style="width: 300px; vertical-align: text-top">
                        <div>
                          <span style="font-size: 11pt; font-weight: bold">Orders</span>
                          <p style="margin-top: 0;margin-bottom: 0; max-width: 300px;">{{ initvalue.transactions.map(item=>item.transnum.toString()).join(', ') }}</p>
                        </div>
                      </td>
                      <td>&nbsp;&nbsp;</td>
                      <td style="width: 45%; text-align: right; vertical-align: text-top">
                        <table  style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Bank Account</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{  accounts.find(account=>account._id == initvalue.accountid)['accountname']  }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Location</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  locations.find(location=>location._id == initvalue.locationid)['locationname']  }}</span></td>
                          </tr>
                          <tr v-if="initvalue.userid">
                            <td><span style="font-size: 11pt; font-weight: bold">Rep</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  users.find(user=>user._id == initvalue.userid)['username']  }}</span></td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <div>&nbsp;&nbsp;</div>
                </v-row>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">#</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Order Num</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Type</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Name</th>
                      <th style="text-align: right; border-bottom: 1px; border-bottom-style: solid">Amount</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(trans, index) in initvalue.transactions"  v-bind:key="trans._id">
                          <td>{{ index + 1 }}</td>
                          <td>{{ trans.transnum }}</td>
                          <td>{{ trans.transtype }}</td>
                          <td>{{ trans.transname }}</td>
                          <td style="text-align: right">{{ trans.transamount }}</td>
                        </tr>
                        <tr><td colspan="5" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
                        <tr>
                          <td colspan="3" rowspan="3" style="vertical-align: text-top; "><strong>Note:</strong>{{ initvalue.depositnote }}</td>
                          <td colspan="1"><span style="font-size: 11pt; font-weight: bold">Total: </span></td>
                          <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.deposittotal }}</span></td>
                        </tr>
                    </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo } from '../../../util/tools';
    export default {
        name: 'PrintPage',
        data(){
          return {
            initvalue: {},
            logo: null,
          };
        },
        methods: {
          ...mapActions('Account', ['getAccountsRequest']),
          ...mapActions('User', ['getUsersRequest']),
          ...mapActions('Location', ['getLocationsRequest']),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()

            setTimeout(function() {
              mywindow.print();
            }, 1000);
            return;
          }
        },
        computed: {
          ...mapState('Account', ['accounts']),
          ...mapState('Location', ['locations']),
          ...mapState('User', ['users']),
        },
        async created () {
          this.initvalue = this.$route.params;
          if(!this.initvalue._id) this.$router.push({ name: 'BatchDepositList' });
          if(this.accounts.length==0) await this.getAccountsRequest();
          if(this.locations.length==0) await this.getLocationsRequest();
          if(this.users.length==0) await this.getUsersRequest();
          this.logo = getLogo(this.initvalue.companyid);
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
